import * as React from 'react'
import FormControlLabel from '@mui/material/FormControlLabel'
import Typography from '@mui/material/Typography'
import Switch from '@mui/material/Switch'
import Box from '@mui/material/Box'

type Props = {
  hideOptional: boolean
  onChangeHideOptional: (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void
}

export function ShowRequiredFieldsToggle(props: Props) {
  const { hideOptional, onChangeHideOptional } = props

  return (
    <Box display="flex" alignItems="center">
      <FormControlLabel
        sx={{ mb: 0, ml: 0 }}
        labelPlacement="end"
        label={<Typography variant="body2">Express view</Typography>}
        data-test-id="show-required-fields-toggle"
        control={
          <Switch
            size="small"
            checked={hideOptional}
            onChange={onChangeHideOptional}
          />
        }
      />
    </Box>
  )
}
